import { QueryClient } from "@tanstack/react-query";

const RETRIABLE_STATUS_CODES_REGEX = /^(5\d{2}|408)$/;
const MAX_RETRY_ATTEMPTS = 3;

const shouldRetryRequest = (failureCount: number, error: any): boolean => {
    return (
        failureCount < MAX_RETRY_ATTEMPTS &&
        (RETRIABLE_STATUS_CODES_REGEX.test(error?.response?.status?.toString()) ||
            error?.code === "NETWORK_ERROR" ||
            error?.message?.includes("NetworkError"))
    );
};

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 15 * 60 * 1000, //15 minutes
            gcTime: 15 * 60 * 1000, //15 minutes
            networkMode: "online",
            retry: shouldRetryRequest,
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            refetchOnMount: false,
        },
    },
});

export default queryClient;
